import { type CreateJingleCollectionModel } from '@/shared/api'

export const MAX_FIELD_LENGTH: {
  [key in keyof Required<Pick<CreateJingleCollectionModel, 'name'>>]: number
} = {
  name: 150,
}
